import { BadgeCheck } from "lucide-react";

/** Synlig märkning för redaktions- och community-konton (transparens). */
export function AuthorBadge({ badge, className = "" }: { badge?: string | null; className?: string }) {
  if (!badge) return null;
  const isTeam = badge.toLowerCase().includes("team");
  return (
    <span
      title={
        isTeam
          ? "Konto som tillhör AK Husbil & Fritid"
          : "Redaktionellt community-konto som startar trådar"
      }
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
        isTeam
          ? "border-accent/40 bg-accent/10 text-accent"
          : "border-border bg-muted/60 text-muted-foreground"
      } ${className}`}
    >
      <BadgeCheck size={11} /> {badge}
    </span>
  );
}
